export const mockFormValue = 'FormValue';
export const mockLongLengthOptionValue =
  'Selected option is too long for option click button. Maximum length of option is 50. So we need to add more than 50 for satisfy the condition';
export const mockSmallLengthOptionValue = 'Example Option';
